const setSettings = (settings: {} | null) => ({
  type: 'SET_SETTINGS',
  ...settings,
})

export default setSettings
